import type { OrderDisplayStatus } from "@optimist/schemas"
import type { StatusBadgeVariant } from "@/components/status-badge"

// Exhaustive so new lifecycle states require an intentional semantic tone.
const ORDER_STATUS_VARIANTS = {
	CREATED: "default",
	PAYMENT_REFUNDED: "default",
	VISIT_CANCELLED: "default",
	REFILL_CANCELLED: "default",
	CANCELLED: "default",
	EXPIRED: "default",
	QUESTIONNAIRE_SUBMITTED: "success",
	ELIGIBILITY_PASSED: "success",
	PAYMENT_APPROVED: "success",
	LAB_KIT_DELIVERED: "success",
	LAB_SAMPLE_DELIVERED: "success",
	LAB_SAMPLE_RECEIVED: "success",
	LAB_RESULTS_APPROVED: "success",
	VISIT_COMPLETED: "success",
	PRESCRIPTION_APPROVED: "success",
	PHARMACY_DELIVERED: "success",
	REFILL_RELEASED: "success",
	CORRECTION_SUBMITTED: "success",
	CORRECTION_APPROVED: "success",
	COMPLETED: "success",
	LAB_ORDERED: "info",
	LAB_KIT_SHIPPED: "info",
	LAB_SAMPLE_IN_TRANSIT: "info",
	LAB_RESULTS_PENDING: "info",
	VISIT_CONFIRMED: "info",
	PHARMACY_DISPATCHED: "info",
	REFILL_ELIGIBLE: "info",
	REFILL_UPCOMING: "info",
	CORRECTION_IN_PROGRESS: "info",
	ON_HOLD: "warning",
	PAYMENT_PENDING: "warning",
	PAYMENT_RETRY_ALLOWED: "warning",
	LAB_REQUIRED: "warning",
	LAB_REORDER_REQUIRED: "warning",
	REFILL_LOCKED: "warning",
	REFILL_PAYMENT_PENDING: "warning",
	CORRECTION_REQUIRED: "warning",
	ELIGIBILITY_FAILED: "destructive",
	PAYMENT_FAILED: "destructive",
	PAYMENT_RETRY_EXHAUSTED: "destructive",
	LAB_RESULTS_REJECTED: "destructive",
	LAB_FAILED: "destructive",
	PRESCRIPTION_REJECTED: "destructive",
	PHARMACY_FAILED: "destructive",
	CORRECTION_REJECTED: "destructive",
} satisfies Record<OrderDisplayStatus, StatusBadgeVariant>

export function getOrderStatusBadgeVariant(status: string): StatusBadgeVariant {
	const normalizedStatus = status.toUpperCase()
	return Object.hasOwn(ORDER_STATUS_VARIANTS, normalizedStatus)
		? ORDER_STATUS_VARIANTS[normalizedStatus as OrderDisplayStatus]
		: "default"
}

export function formatOrderStatusBadgeLabel(status: string): string {
	return status === "ON_HOLD" ? "On hold" : status.replace(/_/g, " ").toLowerCase()
}
